






























import { Vue, Component, Prop } from "vue-property-decorator";
import FormInput from "@/components/lib/input/FormInput.vue";

export interface EditCompanyEmployeePasswordModalFormMethods {
  getNewPasswordValue(): { newPassword: string };
  resetFields(): void;
}

@Component({
  components: {
    FormInput,
  },
})
export default class EditCompanyEmployeePasswordModalForm extends Vue
  implements EditCompanyEmployeePasswordModalFormMethods {
  @Prop({ type: Number }) employeeId: number;
  @Prop({ type: Boolean }) disabled: boolean;
  @Prop({ type: Boolean, default: false }) isLoading?: boolean;

  password = "";
  repeatPassword = "";

  passwordChange(text: string) {
    this.password = text;
  }

  repeatPasswordChange(text: string) {
    this.repeatPassword = text;
  }

  public getNewPasswordValue() {
    return {
      newPassword: this.password,
    };
  }

  public resetFields() {
    this.password = "";
    this.repeatPassword = "";
  }
}
